  import { Layout, Descriptions, Avatar } from "antd";
  import Sidebar from "../components/Sidebar";
  import TopBar from "../components/TopBar";
  import { Input, Button } from "antd";
  import { MailOutlined, EyeOutlined } from "@ant-design/icons";
  import React, { useState, useRef } from "react";
  import {
    changepassword,
    uploadAdminImage,
    BASE_URL,
    updateImage,
  } from "../services/api";
  import Swal from "sweetalert2";
  const adminemail = sessionStorage.getItem("email");
  const adminPassword = sessionStorage.getItem("password");
  const adminImage = sessionStorage.getItem("profileImage");

  const { Content } = Layout;

  const UserProfile = () => {
    const [password, setPassword] = useState(adminPassword);
    const [defpassword, setdefPassword] = useState(adminPassword);
    const [avatarUrl, setAvatarUrl] = useState(BASE_URL + adminImage);
    const fileInputRef = useRef(null);

    const handleImageUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const fileUrl = URL.createObjectURL(file);
        setAvatarUrl(fileUrl);

        const formData = new FormData();
        formData.append("image", file);

        try {
          const response = await uploadAdminImage(formData);
          console.log(response);

          const imageUrl = response.imageUrl;
          console.log(imageUrl);
          await sessionStorage.setItem("profileImage", imageUrl);
          const response2 = await updateImage(imageUrl);

          window.location.reload();
        } catch (error) {
          console.error("Error uploading image:", error);
        }
      }
    };

    const handleAvatarClick = () => {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to change profile picture?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, proceed!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (fileInputRef.current) {
          fileInputRef.current.click();
          
        }
      });
    };
    const handlePass = (e) => {
      setPassword(e.target.value);
    };

    const handlePasswordChange = async (e) => {
      const response = await changepassword(password);
      if (response.status == 200) {
        sessionStorage.setItem("password", password);

        Swal.fire({
          title: `Password has been changed.`,
          icon: "Success",

          confirmButtonText: "Ok",
        });
      }
    };

    return (
      <>     
  <div className="p-6">
      <Layout style={{ minHeight: "100vh", backgroundColor: "#1E1E1E" }}>
        <div
          style={{
            backgroundColor: "#2E2E2E",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            position: "relative",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "80px",
              background: "linear-gradient(90deg, #FBD146 0%, #7ADF75 100%)",
              borderRadius: "8px 8px 0 0",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          ></div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "40px",
              marginBottom: "40px",
            }}
          >
            <div className="flex items-center">
              <Avatar
                className="w-1/6 cursor-pointer"
                src={avatarUrl}
                size={150}
                style={{
                  border: "4px solid #1E1E1E",
                  marginRight: "20px",
                }}
                onClick={handleAvatarClick}
              />

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
            </div>{" "}
            <div
              className="w-1/4"
              style={{
                backgroundColor: "#2e2e2e",
                color: "#FFF",
                textAlign: "left",
              }}
            >
              <h2 style={{ marginBottom: "0" }}>{adminemail}</h2>
              <p style={{ color: "#A9A9A9", marginTop: "8px" }}>Administrator</p>
            </div>
          </div>
          <div
            className="h-10"
            style={{
              backgroundColor: "#1E1E1E",
              padding: "7px 10px",
              borderRadius: "8px",
              marginTop: "",
            }}
          >
            <p style={{ color: "#FFF", marginBottom: "0" }}>
              Update your account preferences using the options below.
            </p>
          </div>
          <div style={{ marginTop: "20px" }}>
            <label
              style={{
                color: "#FFF",
                fontSize: "14px",
                display: "block",
                marginBottom: "5px",
              }}
            >
              Email ID
            </label>
            <Input
              value={adminemail}
              suffix={<MailOutlined style={{ color: "#000000" }} />}
              style={{
                marginBottom: "20px",
                backgroundColor: "#2E2E2E",
                borderColor: "#444",
                color: "#FFF",
                borderRadius: "8px",
                padding: "10px",
              }}
              disabled
            />
            <label
              style={{
                color: "#FFF",
                fontSize: "14px",
                display: "block",
                marginBottom: "5px",
              }}
            >
              Password
            </label>

            <Input.Password
              value={password}
              type="password"
              suffix={
                <EyeOutlined
                  style={{
                    color: "#2e2e2e",
                    fontSize: "16px",
                  }}
                />
              }
              defaultValue={defpassword}
              onChange={handlePass}
              style={{
                marginBottom: "20px",
                backgroundColor: "#2E2E2E",
                borderColor: "#444",
                color: "#FFF",
                borderRadius: "8px",
                padding: "10px",
              }}
            />
          </div>
          <Button
            type="primary"
            style={{
              background: "linear-gradient(90deg, #FBD146 0%, #7ADF75 100%)",
              borderColor: "transparent",
              color: "#F1F1F1",
              fontWeight: "bold",
              width: "20%",
              height: "8%",
              padding: "10px 0",
              borderRadius: "8px",
            }}
            onClick={handlePasswordChange}
          >
            Change Password
          </Button>
        </div>
      </Layout></div></>
    );
  };

  export default UserProfile;
